import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { DynamicBarChart } from 'src/App/Dashboards/Market/Components/Charts';
import { COLOR_PRIMARY_1_500, COLOR_PRIMARY_1_800 } from 'src/utils/colors';
import { BarGraphData } from 'src/interfaces/idashboard';
import { abbreviateNumber, convertCurrency } from 'src/utils/functions';
import { exchangeRates } from 'src/utils/const';

const TrendsChart = ({
  yearlyYoYChange,
  isDisabled,
  currency,
  setTrendGraphData
}) => {

  const futureYear = String(Number(new Date().getFullYear()) + 1);

  const getTooltipText = (data: number, key: string) => {
    if(!data || isNaN(data)){
      return "";
    }

    const lessOrMore = Number(data) < 0 ? 'less' : 'more';
    data = Math.abs(data);
    return key == futureYear ? `Typical listings are predicted to earn ${data}% ${lessOrMore} than this year based on 3-year trend.` : `Typical listings earned ${data}% ${lessOrMore} than the previous year.`
  }

  const getGraphData = () => {
    try{
      const years = Object.keys(yearlyYoYChange).map(Number).sort((a, b) => a - b);

      const graphData = years.map(year => (
        {
          key: year,
          keyShort: year,
          keyLong: year,
          value: Number(yearlyYoYChange[year].toFixed(2))
        }
      ));

      setTrendGraphData(graphData);

      return graphData;
    }catch(err){
      console.error("Error: ", err);
      setTrendGraphData([]);
      return [];
    }
  }

  const dummyTrendsData = [
    {
      keyLong: '2022',
      keyShort: '2022',
      value: 5,
    },
    {
      keyLong: '2023',
      keyShort: '2023',
      value: 15,
    },
    {
      keyLong: '2024',
      keyShort: '2024',
      value: 7,
    },
    {
      keyLong: '2025',
      keyShort: '2025',
      value: 25,
    }
  ] as BarGraphData[];

  const graphData = isDisabled ? dummyTrendsData : (getGraphData() as unknown) as BarGraphData[];

  const Legends = () => {
    return (
      <Grid
        container
        item
        justifyContent={'center'}
        alignItems={'center'}
        xs={12}
        sx={{ marginTop: '20px' }}
      >
        <Grid
          item
          justifyContent={'flex-end'}
          alignItems={'center'}
          sx={{ gap: '10px' }}
        >
          <Typography variant="body2">% Revenue change from previous year</Typography>
        </Grid>
      </Grid>
    );
  };

  return (
    <Box
      sx={{
        width: '100%',
        borderRadius: '8px',
      }}
    >
      <Grid container xs={12} sx={{ padding: '10px' }}>
        {/* <Grid item xs={12}>
          <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
            Trend
          </Typography>
        </Grid> */}
        <Grid item xs={12}>
          <DynamicBarChart
            layout="horizontal"
            data={graphData}
            unit={'%'}
            label="Trend"
            height={180}
            barColor={COLOR_PRIMARY_1_800}
            barAccentColor={COLOR_PRIMARY_1_500}
            useShortHand={true}
            isPropertySizeGraph={true}
            getTooltipText={getTooltipText}
          />
        </Grid>
        <Grid item xs={12}>
          <Legends />
        </Grid>
      </Grid>
    </Box>
  );
};

export default TrendsChart;
